import PropTypes from 'prop-types'
import React, { Component } from 'react'
import _get from 'lodash/get'
import _assign from 'lodash/assign'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _parseInt from 'lodash/parseInt'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import _partial from 'lodash/partial'
import _debounce from 'lodash/debounce'
import FormsyForm from 'formsy-react'
import { connect as connectStaticText } from '../../StaticText/connect'
import { connect as connectPage, PAGE_SEO_TYPE_LOCATION } from '../../Page/connect'
import { selectCurrentUserProfilePicture } from '../../../services/community/identity/profile/redux/selectors'
import { posthog, POSTHOG_FEATURE_FLAGS } from '../../PostHog/index'
import { isBrowser } from '../../../config/environment'
import { get as getConfig } from '../../../config/index'
import Button, { TYPES } from '../../Button/index'
import {
  format as formatDateTime,
  DAY_OPTIONS,
  MONTH_OPTIONS,
  YEAR_OPTIONS,
} from '../../../services/date-time/index'
import VerticalNavigation, { ACCOUNT } from '../../VerticalNavigation/index'
import {
  EmailInput,
  Textarea,
  TextInput,
  Select,
} from '../../FormInput.v2/index'
import { URL_REFER } from '../../../services/url/constants'
import Support from '../../Support/index'
import Sherpa, { TYPE_SMALL_BLUE, TYPE_LARGE } from '../../Sherpa/index'
import { TYPE_UPDATE_PROFILE_IMAGE, TYPE_LOGIN } from '../../../services/dialog/index'
import { getBoundActions } from '../../../actions/index'
import { USERNAME_REGEX } from '../../../services/user/index'
import { H2, H5 } from '../../Heading/index'
import { Card, STATES, CONTROLS } from '../../Card/index'
import ChangePassword from './ChangePassword'
import AccountSecurity from './AccountSecurity'

const config = getConfig()

function isCommunityProfileEnabled () {
  if (!config?.features?.communityProfile) return false
  if (!config?.features?.posthog) return true
  if (!isBrowser()) return false
  return !!posthog.getFeatureFlag(
    POSTHOG_FEATURE_FLAGS.COMMUNITY_EMPLOYEE_TEST,
  )
}

const updateProfileImageClick = (e, setOverlayDialogVisible) => {
  e.preventDefault()
  setOverlayDialogVisible(TYPE_UPDATE_PROFILE_IMAGE)
}

function getAvatarStyle (image) {
  const style = {}
  if (image) {
    style.backgroundImage = `url(${image})`
  }
  return style
}

function onValidPasswordSubmit (model, props, toggleState) {
  const { auth, updateUser } = props
  const password = {
    current: model.password,
    updated: model.newPassword,
  }
  updateUser({ auth, password })
  toggleState()
}

const PROFILE_FORM_SCHEMA = {
  formValid: false,
}

class MyAccountProfilePage extends Component {
  constructor (props) {
    super(props)
    this.state = _assign(
      {},
      PROFILE_FORM_SCHEMA,
    )
  }

  componentDidMount () {
    const {
      auth,
      setOverlayDialogVisible,
      setDialogOptions,
      setOverlayCloseOnClick,
    } = this.props
    const isLoggedIn = !!auth.get('jwt')
    if (!isLoggedIn) {
      setOverlayDialogVisible(TYPE_LOGIN)
      setDialogOptions(null, true)
      setOverlayCloseOnClick(false)
    }
  }

  componentDidUpdate (prevProps) {
    const { user: nextUser } = this.props
    const { user: previousUser } = prevProps
    const nextUpdateUserSuccess = nextUser.getIn(['updateUser', 'success'])
    const previousUpdateUserSuccess = previousUser.getIn(['updateUser', 'success'])
    if (nextUpdateUserSuccess !== previousUpdateUserSuccess) {
      this.setState(() => (PROFILE_FORM_SCHEMA)) // eslint-disable-line
    }
  }

  componentWillUnmount () {
    const { clearUserProfileData } = this.props
    clearUserProfileData()
  }

  onValidSubmit = (model, props, toggleState) => {
    const { state } = this
    const { auth, updateUser } = props
    let birthday = null
    const { email } = state
    const { username } = state
    const { bio } = state
    const { location } = state
    const { day } = state
    const { month } = state
    const { year } = state
    const { firstName } = state
    const { lastName } = state
    if (day && month && year) {
      birthday = new Date(`${year}-${month}-${day}`)
    }
    updateUser({
      auth, email, username, bio, location, birthday, firstName, lastName,
    })
    toggleState()
  }

  onChangeForm = (model) => {
    this.setState(() => ({
      email: model.email,
      username: model.userName,
      firstName: model.firstName,
      lastName: model.lastName,
      bio: model.bio,
      location: model.location,
      day: model.day !== undefined ? model.day : '',
      month: model.month !== undefined ? model.month : '',
      year: model.year !== undefined ? model.year : '',
    }))
  }

  onClickAccountSecurity = () => {
    const { auth, doAuthRenew } = this.props
    doAuthRenew(auth, true)
  }

  setFormValid = (valid) => {
    /* eslint-disable no-else-return */
    if (valid) {
      this.setState(() => ({ formValid: true }))
      return true
    } else {
      this.setState(() => ({ formValid: false }))
      return false
    }
    /* eslint-enable no-else-return */
  }

  renderPasswordEditMode = (toggleState) => {
    const { props, state } = this
    const { staticText } = props
    const { formValid } = state
    const debounceSetFormValid = _debounce(this.setFormValid, 100)

    return (
      <div className="account-profile__profile-container edit">
        <H5>{staticText.getIn(['data', 'changePassword'])}</H5>
        <FormsyForm
          className="account-profile__form"
          onValidSubmit={_partial(
            onValidPasswordSubmit,
            _partial.placeholder,
            this.props,
            toggleState,
          )}
          onValid={_partial(debounceSetFormValid, true)}
          onInvalid={_partial(debounceSetFormValid, false)}
        >
          <ChangePassword staticText={staticText} />
          <div className="account-profile__buttons">
            <Button
              type={TYPES.PRIMARY}
              submit
              disabled={!formValid}
              className="account-profile__form-button"
            >
              {staticText.getIn(['data', 'save'])}
            </Button>
            <Button
              type={TYPES.GHOST}
              onClick={toggleState}
              className="account-profile__form-button account-profile__form-button--cancel"
            >
              {staticText.getIn(['data', 'cancel'])}
            </Button>
          </div>
        </FormsyForm>
      </div>
    )
  }

  renderPasswordViewMode = () => {
    const { props } = this
    const { staticText } = props

    return (
      <div className="account-profile__profile-container">
        <div className="account-profile__form-container">
          <H5>{staticText.getIn(['data', 'changePassword'])}</H5>
          {staticText.getIn(['data', 'changeYourPassword'])}
        </div>
      </div>
    )
  }

  renderProfileEditMode = (matchingProfile, toggleState) => {
    const {
      staticText, setOverlayDialogVisible, user, currentUserPicture,
    } = this.props
    const { formValid } = this.state

    const avatarImage = isCommunityProfileEnabled() && currentUserPicture
      ? currentUserPicture.card
      : user.getIn(['data', 'profile', 'picture', 'hdtv_190x266'])
    const processing = user.get('updateUserProcessing')
    const userMail = user.getIn(['data', 'mail'], '')
    const userName = user.getIn(['data', 'name'], '')
    const userEmail = user.getIn(['data', 'email'], '')
    const userUsername = user.getIn(['data', 'username'], '')
    const username = userUsername || userName
    const email = userEmail || userMail
    const bio = user.getIn(['data', 'profile', 'bio'], '')
    const firstName = matchingProfile.get('first_name', '')
    const lastName = matchingProfile.get('last_name', '')
    const profileLocation = user.getIn(['data', 'profile', 'location'], '')
    const debounceOnChangeForm = _debounce(this.onChangeForm, 100)
    const debounceSetFormValid = _debounce(this.setFormValid, 100)
    const statusCode = user.getIn(['updateUser', 'statusCode'])

    const birthday = matchingProfile.get('birthday', '')
    const formattedBirthday = birthday ? formatDateTime(birthday, null, 'D/M/YYYY') : ''
    const splitBirthday = formattedBirthday.split('/')
    const month = splitBirthday[1] || undefined
    const year = splitBirthday[2] || undefined
    const day = splitBirthday[0] || undefined

    return (
      <div className="account-profile__profile-container edit">
        <div className="account-profile__avatar-container">
          <div className="account-profile__avatar-outline">
            <H5>{staticText.getIn(['data', 'profilePhoto'])}</H5>
            <div className="account-profile__avatar-placement">
              <div className="account-profile__avatar-cell">
                <div className="account-profile__avatar" style={getAvatarStyle(avatarImage)} />
              </div>
              <div className="account-profile__avatar-btn-cell">
                <Button
                  type={TYPES.SECONDARY}
                  onClick={(e) => updateProfileImageClick(e, setOverlayDialogVisible)}
                  className="account-profile__upload-avatar"
                >
                  {staticText.getIn(['data', 'upload'])}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className="account-profile__sep" />
        <div className="account-profile__form-container">
          {
            processing
              ? <div className="account-profile__processing">
                <Sherpa className={['account-profile__sherpa']} type={TYPE_SMALL_BLUE} />
                <div className="account-profile__processing-text">
                  {`${staticText.getIn(['data', 'saving'])}...`}
                </div>
              </div>
              : null
          }
          {
            statusCode > 299
              ? <div className="account-profile__error">
                {staticText.getIn(['data', 'genericError'])}
              </div> : null
          }
          <FormsyForm
            className="account-profile__form"
            onValidSubmit={_partial(
              this.onValidSubmit,
              _partial.placeholder,
              this.props,
              toggleState,
            )}
            onValid={_partial(debounceSetFormValid, true)}
            onInvalid={_partial(debounceSetFormValid, false)}
            onChange={_partial(debounceOnChangeForm)}
          >
            <div className="account-profile__label-container">
              <H5>{staticText.getIn(['data', 'personalInformation'])}</H5>
            </div>
            <div className="account-profile__input-container">
              <TextInput
                name="userName"
                label={staticText.getIn(['data', 'userName'])}
                labelClassName={['account-profile__form-label__edit', 'edit-label']}
                value={username}
                required
                validations={{
                  matchRegexp: USERNAME_REGEX,
                }}
                validationErrors={{
                  matchRegexp: staticText.getIn(['data', 'usernameValidError']),
                }}
              />
            </div>
            <div className="account-profile__input-container">
              <TextInput
                name="firstName"
                label={staticText.getIn(['data', 'firstName'])}
                labelClassName={['account-profile__form-label__edit', 'edit-label']}
                value={firstName}
                required
                validations={{
                  maxLength: 255,
                }}
                validationErrors={{
                  matchRegexp: staticText.getIn(['data', 'usernameValidError']),
                }}
              />
            </div>
            <div className="account-profile__input-container">
              <TextInput
                name="lastName"
                label={staticText.getIn(['data', 'lastName'])}
                labelClassName={['account-profile__form-label__edit', 'edit-label']}
                value={lastName}
                validations={{
                  maxLength: 255,
                }}
                validationErrors={{
                  matchRegexp: staticText.getIn(['data', 'usernameValidError']),
                }}
              />
            </div>
            <div className="account-profile__input-container">
              <EmailInput
                name="email"
                label={staticText.getIn(['data', 'email'])}
                labelClassName={['account-profile__form-label__edit', 'edit-label']}
                value={email}
                required
                validations={{ isEmail: true }}
                validationErrors={{
                  isEmail: staticText.getIn(['data', 'emailValidError']),
                }}
              />
            </div>
            <div className="account-profile__form account-profile__hidden">
              <div className="account-profile__input-container">
                <TextInput
                  name="location"
                  label={staticText.getIn(['data', 'location'])}
                  labelClassName={['account-profile__form-label', 'edit-label']}
                  value={profileLocation}
                  validations={{
                    maxLength: 255,
                  }}
                  validationErrors={{
                    maxLength: staticText.getIn(['data', 'locationMaxLength']),
                  }}
                />
              </div>
              <div className="account-profile__sep" />
              <div className="account-profile__label-container">
                <H5>{staticText.getIn(['data', 'birthday'])}</H5>
              </div>
              <div className="form-input account-profile__form-birthday">
                <div className="account-profile__form-birthday-select-month">
                  <Select
                    name="month"
                    label={staticText.getIn(['data', 'month'])}
                    value={month}
                    placeholder={staticText.getIn(['data', 'selectMonth'])}
                  >
                    {MONTH_OPTIONS.map((option, index) => (
                      <option value={option.value} key={`birthday-month-${index}`}>
                        {option.label}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="account-profile__form-birthday-select-day">
                  <Select
                    name="day"
                    label={staticText.getIn(['data', 'day'])}
                    value={day}
                    placeholder={staticText.getIn(['data', 'selectDay'])}
                  >
                    {DAY_OPTIONS.map((option, index) => (
                      <option value={option.value} key={`birthday-day-${index}`}>
                        {option.label}
                      </option>
                    ))}
                  </Select>
                </div>
                <div className="account-profile__form-birthday-select-year">
                  <Select
                    name="year"
                    label={staticText.getIn(['data', 'year'])}
                    value={year}
                    placeholder={staticText.getIn(['data', 'selectYear'])}
                  >
                    {YEAR_OPTIONS.map((option, index) => (
                      <option value={option.value} key={`birthday-day-${index}`}>
                        {option.label}
                      </option>
                    ))}
                  </Select>
                </div>
              </div>
              <div className="account-profile__sep" />
              <div className="account-profile__label-container">
                <H5>{staticText.getIn(['data', 'additionalInformation'])}</H5>
              </div>
              <Textarea
                name="bio"
                className="account-profile__form-text-area"
                label={staticText.getIn(['data', 'bio'])}
                labelClassName={['account-profile__form-label', 'edit-label']}
                value={bio}
                validations={{
                  maxLength: 255,
                }}
                validationErrors={{
                  maxLength: staticText.getIn(['data', 'bioMaxLength']),
                }}
              />
            </div>
            <div className="account-profile__sep" />
            <div className="account-profile__buttons">
              <Button
                type={TYPES.PRIMARY}
                submit
                disabled={!formValid}
                className="account-profile__form-button"
              >
                {staticText.getIn(['data', 'save'])}
              </Button>
              <Button
                type={TYPES.GHOST}
                onClick={toggleState}
                className="account-profile__form-button account-profile__form-button--cancel"
              >
                {staticText.getIn(['data', 'cancel'])}
              </Button>
            </div>
          </FormsyForm>
        </div>
      </div>
    )
  }

  renderProfileViewMode = (matchingProfile) => {
    const { staticText, user, currentUserPicture } = this.props
    const avatarImage = isCommunityProfileEnabled() && currentUserPicture
      ? currentUserPicture.card
      : user.getIn(['data', 'profile', 'picture', 'hdtv_190x266'])
    const processing = user.get('updateUserProcessing')
    const userMail = user.getIn(['data', 'mail'], '')
    const userId = user.getIn(['data', 'uid'])
    const userName = user.getIn(['data', 'name'], '')
    const userEmail = user.getIn(['data', 'email'], '')
    const userUsername = user.getIn(['data', 'username'], '')
    const email = userEmail || userMail
    const username = userUsername || userName
    const bio = user.getIn(['data', 'profile', 'bio'], '')
    const birthday = matchingProfile.get('birthday', '')
    const formattedBirthday = birthday ? formatDateTime(birthday) : ''
    const name = `${matchingProfile.get('first_name', '') || ''} ${matchingProfile.get('last_name', '') || ''}`
    const profileLocation = user.getIn(['data', 'profile', 'location'], '')
    const statusCode = user.getIn(['updateUser', 'statusCode'])

    return (
      <div className="account-profile__profile-container">
        <div className="account-profile__avatar-container">
          <div className="account-profile__avatar-outline">
            <div className="account-profile__avatar" style={getAvatarStyle(avatarImage)} />
          </div>
        </div>
        <div className="account-profile__form-container">
          {
            processing
              ? <div className="account-profile__processing">
                <Sherpa className={['account-profile__sherpa']} type={TYPE_SMALL_BLUE} />
                <div className="account-profile__processing-text">
                  {`${staticText.getIn(['data', 'saving'])}...`}
                </div>
              </div>
              : null
          }
          {
            statusCode > 299
              ? <div className="account-profile__error">
                {staticText.getIn(['data', 'genericError'])}
              </div> : null
          }
          <div className="account-profile__user-container">
            <div className="account-profile__form-bio">
              <H5>{staticText.getIn(['data', 'userId'])}</H5>
              <span className="account-profile__view-info">
                {userId}
              </span>
            </div>
            <div className="account-profile__form-bio">
              <H5>{staticText.getIn(['data', 'userName'])}</H5>
              <span className="account-profile__view-info">
                {username}
              </span>
            </div>
          </div>
          <div className="account-profile__user-container">
            <div className="account-profile__form-bio">
              <H5>{staticText.getIn(['data', 'name'])}</H5>
              <span className="account-profile__view-info">
                {name}
              </span>
            </div>
            <div className="account-profile__form-bio">
              <H5>{staticText.getIn(['data', 'email'])}</H5>
              <span className="account-profile__view-info">
                {email}
              </span>
            </div>
            <div className="account-profile__form-bio account-profile__hidden">
              <H5>{staticText.getIn(['data', 'location'])}</H5>
              <span className="account-profile__view-info">
                {profileLocation}
              </span>
            </div>
            <div className="account-profile__form-bio account-profile__hidden">
              <H5>{staticText.getIn(['data', 'birthday'])}</H5>
              <span className="account-profile__view-info">
                {formattedBirthday}
              </span>
            </div>
          </div>
          <div className="account-profile__form-bio account-profile__hidden">
            <H5>{staticText.getIn(['data', 'bio'])}</H5>
            <span className="account-profile__view-info">
              {bio}
            </span>
          </div>
        </div>
      </div>
    )
  }

  renderReferral = () => {
    const { props } = this
    const { staticText } = props

    return (
      <div className="account-profile__referral-container">
        <div className="account-profile__form-container">
          <H5>{staticText.getIn(['data', 'inviteAFriend'])}</H5>
          <p>
            {staticText.getIn(['data', 'sendALink'])}
          </p>
          <div className="account-profile__refer-btn-container">
            <Button
              type={TYPES.GHOST}
              url={URL_REFER}
              className="account-profile__refer-button"
              scrollToTop
            >
              {staticText.getIn(['data', 'invite'])}
            </Button>
            <div className="account-profile__icon-right" />
          </div>
        </div>
      </div>
    )
  }

  render () {
    const {
      auth, location, staticText, user, userProfiles,
    } = this.props
    const userData = user.get('data')
    const userProfileData = userProfiles.get('data')
    const accountSecurity = _get(config, ['features', 'accountSecurity'])

    return (
      <React.Fragment>
        <div className="my-account__grid">
          <VerticalNavigation location={location} navType={ACCOUNT} />
          <div className="my-account my-account__content-box">
            <div className="account-profile__title">
              <H2>{staticText.getIn(['data', 'title'])}</H2>
            </div>
            {!userData || !userProfileData ? (
              <Sherpa type={TYPE_LARGE} />
            ) : (
              <Card
                editable
                editControl={CONTROLS.UPDATE}
              >
                {(editState, toggleState) => {
                  const matchingProfile = userProfileData.find((profile) => _parseInt(profile.get('uid')) === userData.get('uid'))
                  return (
                    editState === STATES.EDITING
                      ? this.renderProfileEditMode(matchingProfile, toggleState)
                      : this.renderProfileViewMode(matchingProfile)
                  )
                }}
              </Card>
            )}
            <div className="account-profile__title">
              <H2>{staticText.getIn(['data', 'password'])}</H2>
            </div>
            <Card
              editable
              editControl={CONTROLS.CHANGE}
            >
              {(editState, toggleState) => (
                editState === STATES.EDITING
                  ? this.renderPasswordEditMode(toggleState)
                  : this.renderPasswordViewMode()
              )}
            </Card>
            <div className="account-profile__title">
              <H2>{staticText.getIn(['data', 'community'])}</H2>
            </div>
            <div className="account-profile no-shadow">
              {this.renderReferral()}
            </div>
            {accountSecurity && (
              <div className="account-profile__account-security-container">
                <div className="account-profile__title">
                  <H2>{staticText.getIn(['data', 'accountSecurityTitle'])}</H2>
                </div>
                <Card>
                  <AccountSecurity
                    auth={auth}
                    staticText={staticText}
                    onSubmit={this.onClickAccountSecurity}
                  />
                </Card>
              </div>
            )}
          </div>
        </div>
        <div className="account-profile__support-container">
          <Support />
        </div>
      </React.Fragment>
    )
  }
}

MyAccountProfilePage.propTypes = {
  auth: ImmutablePropTypes.map.isRequired,
  user: ImmutablePropTypes.map.isRequired,
  setOverlayDialogVisible: PropTypes.func.isRequired,
  updateUser: PropTypes.func.isRequired,
  clearUserProfileData: PropTypes.func.isRequired,
}

export default compose(
  connectPage({ seoType: PAGE_SEO_TYPE_LOCATION }),
  connectStaticText({ storeKey: 'myAccountProfilePage' }),
  connectRedux(
    (state) => ({
      currentUserPicture: selectCurrentUserProfilePicture(state),
      user: state.user,
      auth: state.auth,
      userProfiles: state.userProfiles,
      page: state.page,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setOverlayDialogVisible: actions.dialog.setOverlayDialogVisible,
        clearUserProfileData: actions.user.clearUserProfileData,
        updateUser: actions.user.updateUser,
        setDialogOptions: actions.dialog.setDialogOptions,
        setOverlayCloseOnClick: actions.dialog.setOverlayCloseOnClick,
        doAuthRenew: actions.auth.doAuthRenew,
      }
    },
  ),
)(MyAccountProfilePage)
